require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./interviste-alberto-caruso.json") })
        }
      }, "path---interviste-alberto-caruso");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---interviste-alberto-caruso!./.cache/json/interviste-alberto-caruso.json
// module id = 668
// module chunks = 231608221292675